<script context="module">

    export const HS_API_URL = 'https://prod.api.aemtler-bon.ch';


    export const getOrderDetails = async (orderId) => {

        return fetch(window.apiUrl + '/payment/order/details', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json'
            },

            body: JSON.stringify({
                'orderid': orderId
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const getOrderCodes = async (orderId) => {

        return fetch(window.apiUrl + '/codes/order', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json'
            },

            body: JSON.stringify({
                'orderid': orderId
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data;

        });

    };

    export const getMergedPdf = async (orderId, codes) => {

        try {
            const response = await fetch(window.apiUrl + '/codes/mergepdf', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'orderid': orderId,
                    'codes': codes
                })
            });

            if (!response.ok) {
                throw new Error('Network response was not ok: ' + response.statusText);
            }

            // Get and return the blob data
            return await response.blob();

        } catch (error) {
            console.error('Fetching PDF failed', error);
            throw error;  // Propagate error
        }

    };


    export const triggerPdfCreation = async (codeId) => {
        try {
            const response = await fetch(`${window.apiUrl}/codes/pdf?code=${codeId}`);
            if (!response.ok) {
                throw new Error(`Failed to create PDF for code ${codeId}: ${response.statusText}`);
            }
        } catch (error) {
            console.error(error);
            throw error; // Propagate error
        }
    };

    export const createDynamicLink = async (code) => {

        return fetch(window.apiUrl + '/business/dynamiclink', {

            method: 'post',

            headers: {
                'Content-Type': 'application/json'
            },

            body: JSON.stringify({
                "code": code
            })

        }).then((response) => {

            return response.json();

        }).then((data) => {

            return data['data'];

        });

    };


</script>
